import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-skeleton-card',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="skeleton-card">
      <div class="skeleton-image pulse"></div>
      <div class="skeleton-content">
        <div class="skeleton-line pulse w-60"></div>
        <div class="skeleton-line pulse w-100"></div>
        <div class="skeleton-line pulse w-80"></div>
        <div class="skeleton-line pulse w-40 mt-auto"></div>
      </div>
    </div>
  `,
  styles: [`
    .skeleton-card {
      background: #fff;
      border-radius: 12px;
      overflow: hidden;
      height: 320px;
      display: flex;
      flex-direction: column;
      border: 1px solid #f1f2f6;
    }

    .skeleton-image {
      padding-top: 75%;
      background: #f1f2f6;
    }

    .skeleton-content {
      padding: 12px;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .skeleton-line {
      height: 16px;
      background: #f1f2f6;
      border-radius: 4px;
    }

    .pulse {
      animation: pulse 1.5s infinite ease-in-out;
    }

    @keyframes pulse {
      0% { opacity: 0.6; }
      50% { opacity: 1; }
      100% { opacity: 0.6; }
    }

    .w-40 { width: 40%; }
    .w-60 { width: 60%; }
    .w-80 { width: 80%; }
    .w-100 { width: 100%; }
    .mt-auto { margin-top: auto; }
  `]
})
export class SkeletonCardComponent {}
